/* eslint-disable import/no-duplicates */
import { Duration, formatDuration } from 'date-fns';
import { DeclensionScheme, declension, ru } from '@cp/shared/lib/date';

const locale = {
  ...ru,
  formatDistance: (token: string, count: number, options) => {
    const dict: Record<string, DeclensionScheme> = {
      xDays: {
        singularNominative: 'первый день',
        singularGenitive: 'первые {{count}} дня',
        pluralGenitive: 'первые {{count}} дней',
      },
      xWeeks: {
        singularNominative: 'первая неделя',
        singularGenitive: 'первые {{count}} недели',
        pluralGenitive: 'первые {{count}} недель',
      },
      xMonths: {
        singularNominative: 'первый месяц',
        singularGenitive: 'первые {{count}} месяца',
        pluralGenitive: 'первые {{count}} месяцев',
      },
      xYears: {
        singularNominative: 'первый год',
        singularGenitive: 'первые {{count}} года',
        pluralGenitive: 'первые {{count}} лет',
      },
    };
    if (dict[token]) {
      return declension(dict[token], count);
    }
    // @ts-expect-error locale typings
    return ru.formatDistance(token, count, options);
  },
};

export interface IFormatPromocodeDurationOptions {
  wording?: 'default' | 'no-prefix';
}

export const formatPromocodeDuration = (duration: Duration, options: IFormatPromocodeDurationOptions = {}): string => {
  const { wording = 'default' } = options;
  return formatDuration(duration, { locale: wording === 'default' ? locale : ru });
};
